import React, { useContext, useEffect, useState } from "react";
import NavBelt from "../page-essentials/NavBelt";
import { reviewsBreadCrumpData } from "../static-data/breadcrump";

import { AiOutlineHeart } from "react-icons/ai";
import { GrCertificate } from "react-icons/gr";
import { MdOutlineRateReview } from "react-icons/md";
import WriteReviewForm from "../forms/WriteReviewForm";
import ReviewService from "../../services/Review.service";
import { IPackage, IReviewCategory, IReviewsList } from "../../types/global";
import ReviewCard from "../cards/ReviewCard";
import PackagesService from "../../services/Packages.service";
import LangContext from "../../context/LangContext";

const Reviews = () => {
  const [activeTab, setActiveTab] = useState("");
  console.log(activeTab, "acitgve tab =====");
  const [categoriesData, setCategoriesData] = useState<IReviewCategory[]>([]);
  const [reviewData, setReviewData] = useState<IReviewsList[]>([]);
  const [featuredPkgData, setFeaturedPkgData] = useState<IPackage[]>([]);

  const { lang_id } = useContext(LangContext);

  const fetchCategoies = async () => {
    try {
      const res = await ReviewService.fetchCategories();
      setActiveTab(res.data.data[0].id);
      setCategoriesData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchReviews = async (cat_id: string) => {
    try {
      const res = await ReviewService.fetchReviews(`?category=${cat_id}`);
      setReviewData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFeaturedPkgs = async () => {
    try {
      if (lang_id) {
        const res = (await PackagesService.fetchPackages(
          "",
          lang_id,
          true
        )) as any;
        setFeaturedPkgData(res.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleActiveTab = (id: string) => {
    setActiveTab(id);
    fetchReviews(id);
  };

  useEffect(() => {
    fetchFeaturedPkgs();
  }, [lang_id]);

  useEffect(() => {
    fetchCategoies().then(() => {
      fetchReviews(activeTab);
    });
  }, []);

  return (
    <div>
      <NavBelt
        page="Reviews"
        img="https://images.unsplash.com/photo-1539635278303-d4002c07eae3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        breadCrumpInfo={reviewsBreadCrumpData}
      />
      {/* <TestReponsive /> */}
      <div className="container mx-auto px-4 2xl:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* left section of grid  */}
          <div className="md:col-span-7 lg:col-span-8 ">
            <div className="pt-20 pb-8">
              <h1 className="font-bold text-3xl">
                Do not hear from us{" "}
                <span className="text-primary-base">hear from them!</span>
              </h1>
              <p>Our valuable cutomers sharing their experience with us.</p>
              {/* <hr className="my-2 w-1/2" /> */}
            </div>

            <div className="flex items-center space-x-4">
              {/* trip advisor tab button  */}
              {categoriesData.map((item, i) => (
                <div
                  key={i}
                  className={`bg-white px-3 py-2 rounded-lg shadow-md w-44 h-24 group transition duration-300 hover:border-t-4 hover:border-primary-base hover:transition hover:duration-300 ${
                    activeTab === item.id && "border-t-4 border-primary-base"
                  }`}
                  onClick={() => handleActiveTab(item.id)}
                >
                  <img
                    src={`${process.env.REACT_APP_API}/uploads/images/${item.review_category_img}`}
                    alt=""
                    srcSet=""
                    className={`w-full h-full object-contain grayscale group-hover:grayscale-0 transition duration-300 hover:transition ${
                      activeTab === item.id && "grayscale-0"
                    } `}
                  />
                </div>
              ))}
            </div>

            {/* <div className="my-8">{TabLayout}</div> */}

            {reviewData.map((item, i) => (
              <ReviewCard
                key={i}
                reviewType={item.review_category.review_category_name}
                data={{
                  reviewHighlight: item.review_headline,
                  img: item.user_img,
                  location: item.address,
                  name: item.name,
                  review: item.message,
                  stars: item.rating,
                }}
                reviewRef={null}
              />
            ))}
          </div>

          {/* right section of grid  */}
          <div className="md:col-span-5 lg:col-span-4 px-4 relative">
            <div className="pt-14 md:pt-20 pb-8 md:max-h-screen md:overflow-y-auto no-scrollbar md:sticky md:top-8">
              <div className=" text-gray-600 font-medium flex items-center space-x-2">
                <MdOutlineRateReview className="text-primary-base" />
                <h1>Write your review</h1>
              </div>
              <hr className="my-2" />
              <WriteReviewForm />

              <div className=" text-gray-600 font-medium flex items-center space-x-2 mt-12">
                <AiOutlineHeart className="text-primary-base" />
                <h1>Our Featured Treks</h1>
              </div>
              <hr className="my-2" />
              {/* featured trekking card goes here */}
              <div className="grid grid-cols-1">
                {featuredPkgData.map((item, i) => (
                  <div className="flex space-x-2 my-4" key={i}>
                    <img
                      src={`${process.env.REACT_APP_API}/uploads/images/${item.package_img}`}
                      alt=""
                      className="h-20 w-24 object-cover rounded-lg"
                    />
                    <div className="">
                      <p className=" font-semibold line-clamp-1">
                        {item.translation[0].package_title}
                      </p>
                      <p>{item.day} Days</p>
                    </div>
                  </div>
                  // <FeaturedTrekkingCard
                  //     key={i}
                  //     img={item.img}
                  //     tekkingTitle={item.trekkingTitle}
                  // />
                ))}
              </div>

              <div className=" text-gray-600 font-medium flex items-center space-x-2 mt-10">
                <GrCertificate className="text-primary-base" />
                <h1>Our Certifications</h1>
              </div>
              <hr className="my-2" />
              <div className="grid grid-cols-2 my-4 gap-6">
                <div className="bg-gray-100 h-36 md:h-24 lg:h-36 rounded-md w-full"></div>
                <div className="bg-gray-100 h-36 md:h-24 lg:h-36 rounded-md w-full"></div>
                <div className="bg-gray-100 h-36 md:h-24 lg:h-36 rounded-md w-full"></div>
                <div className="bg-gray-100 h-36 md:h-24 lg:h-36 rounded-md w-full"></div>
              </div>
              {/* company certification images goes here */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
